import React from 'react';

import { Polygon3D } from '@paragon/geometry-library';

import { LayoutPolygonVisualMode } from '../../polygon-rendering/common/mode';
import { getRoofFaceColor, LayoutPolygonStyle } from '../../polygon-rendering/common/style';
import { LayoutPolygonFaceMesh } from '../../polygon-rendering/faces/LayoutPolygonFaceMesh';

export function PlaneFaceVisual(props: {
  planeGeometry: readonly Polygon3D[];
  overhangGeometry?: Polygon3D[] | null;
  subfasciaGeometry?: Polygon3D[] | null;

  visible: boolean;
  style: LayoutPolygonStyle;
  mode: LayoutPolygonVisualMode;
}) {
  if (props.mode === 'wireframe') return null;

  const options = { mode: props.mode, color: getRoofFaceColor(props.style), visible: props.visible } as const;

  return (
    <>
      {props.planeGeometry.map((geometry, i) => (
        <LayoutPolygonFaceMesh key={`face_${i}`} geometry={geometry} {...options} />
      ))}

      {props.overhangGeometry &&
        props.overhangGeometry.map((overhang, i) => (
          <LayoutPolygonFaceMesh key={`overhang_${i}`} geometry={overhang} {...options} />
        ))}
      {props.subfasciaGeometry &&
        props.subfasciaGeometry.map((subfascia, i) => (
          <LayoutPolygonFaceMesh key={`subfascia_${i}`} geometry={subfascia} {...options} />
        ))}
    </>
  );
}
